module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/instagram-dark-5979746c60cd8fe723d2e20a9888df59.svg";